import { STRUCTURE_NAME_MAX_LENGTH } from '~/domain/services/dicomProcessor';

const MARGIN_SUFFIX = '_mrg';

/**
 * Build the default margin structure name from an input name,
 * truncating the base so the result fits within the DICOM
 * ROI name length limit.
 */
export function getDefaultMarginName(inputName: string): string {
    const maxBase = STRUCTURE_NAME_MAX_LENGTH - MARGIN_SUFFIX.length;
    return `${inputName.substring(0, maxBase)}${MARGIN_SUFFIX}`;
}
